import { useQuery } from "@tanstack/react-query";
import api from "../../../util/api";
import { UserWithSelectedMembership, QueryKeys } from "../../../util/types";
import { setSelectedCompanyMembership } from "../../../util/company-utils";

export const useGetUser = () => {
  const {
    data: userData,
    isLoading,
    isFetching,
    refetch: refreshUserData,
  } = useQuery<UserWithSelectedMembership, any>({
    queryKey: [QueryKeys.GET_USER],
    queryFn: async () => {
      const result = await api.getUser();
      const selectedCompanyMembership = setSelectedCompanyMembership(
        result.companyMemberships
      );

      return {
        ...result,
        selectedCompanyMembership,
      } as UserWithSelectedMembership;
    },
    placeholderData: (prev) => prev,
  });

  return { userData, loading: isLoading || isFetching, refreshUserData };
};
